import { CircularProgress } from 'material-ui';
import { MuiThemeProvider } from 'material-ui/styles';
import * as React from 'react';
import './loader.scss';

export interface ILoaderProps {
    type: 'async' | 'submission';
    size?: number;
    thickness?: number;
    bgColor?: string;
}

export class Loader extends React.PureComponent<ILoaderProps, {}> {

    public getStyle = () => {
        const { type, bgColor } = this.props;
        if (this.props.type === 'async') {
            return { ...progressStyle, backgroundColor: bgColor };
        } else {
            return submissionLoader;
        }
    }

    public render() {
        const { size, thickness } = this.props;
        return (
            <div style={this.getStyle()} >
                {this.props.type === 'submission' ? <MuiThemeProvider>
                    <CircularProgress size={size || 150} color="#A4BF43" thickness={thickness || 5} />
                </MuiThemeProvider> :
                    <div className="lds-spinner">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                }
            </div>
        );
    }
}

const progressStyle: React.CSSProperties = {
    minHeight: '50vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent'
};

const submissionLoader: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    height: '100%',
    width: '100%',
    zIndex: 1000,
    backgroundColor: 'black',
    opacity: 0.7,
    top: 0,
    left: 0
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/Loader/Loader.tsx